export default __webpack_public_path__ + "static/media/1614_bp.947053a7.svg";